import { Screen } from '~/screens/Branches/new';

export const BranchesNew: React.FC = () => <Screen />;
